import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  COOKIE_NAME = 'token';

  constructor() {
    this.wipeCookies();
  }

  set(name: string, value: string): void {
    localStorage.setItem(name, value ?? '');
  }

  get(name: string): string {
    return localStorage.getItem(name) ?? '';
  }

  remove(name: string): void {
    localStorage.removeItem(name);
  }

  clearAll(): void {
    localStorage.clear();
    this.wipeCookies();
  }

  private wipeCookies(): void {
    document.cookie.split(';').forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      if (name) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      }
    });
  }
}
